import axios from "axios";
import { apiURL } from "utils/config";
import { getAuthorizationHeaders } from "./auth";
import store from "../store";

/**
 * Returns Alerts for contracts
 * @returns {AxiosPromise}
 */

export const getDashboardProspects = () => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });

  const url = (id) => `${apiURL}/school/${id}/dashboard/prospects`;
  return axios({
    url: url(schoolId),
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};

export const getWebsiteLeads = (status) => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  if (status) {
    const url = (id) => `${apiURL}/school/${id}/websiteleads/?status=archive`;
    return axios({
      url: url(schoolId),
      method: "GET",
      headers: getAuthorizationHeaders(),
    });
  } else {
    const url = (id) => `${apiURL}/school/${id}/websiteleads`;
    return axios({
      url: url(schoolId),
      method: "GET",
      headers: getAuthorizationHeaders(),
    });
  }
};

export const postWebsiteLead = (id, status) => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  const url = (id) => `${apiURL}/school/${id}/websiteleads`;
  return axios({
    url: url(schoolId),
    method: "POST",
    data: { id: id, status: status },
    headers: getAuthorizationHeaders(),
  });
};

export const getWebsiteLeadWithStatus = (status) => {
  const schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  const url = (id) => `${apiURL}/school/${id}/websiteleads/?status=${status}`;
  return axios({
    url: url(schoolId),
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};
